export default "__VITE_ASSET__CdQc8Rf7__"